import "core-js/modules/es.array.push.js";
import CoreComponent from '../../core/CoreComponent.vue';
import Cart from './cart.vue';
import Checkout from './checkout/checkout.vue';
import CreditCardPayment from './payment/credit-card-payment.vue';
const routes = [{
  path: '/',
  component: Cart,
  name: 'cart'
}, {
  path: '/checkout',
  component: Checkout,
  name: 'checkout'
}, {
  path: '/payment',
  component: CreditCardPayment,
  name: 'payment'
}, {
  path: '/:pathMatch(.*)*',
  redirect: '/'
}];
export default {
  name: 'PurchaseCart',
  extends: CoreComponent,
  components: {
    Cart,
    Checkout,
    CreditCardPayment
  },
  created() {
    routes.forEach(route => this.$router.addRoute(route));
    let hash = window.location.hash.substring(1);
    if (hash) {
      this.$router.push({
        path: hash
      });
    }
  }
};